import { Email } from "@src/types/api";

function trimSenderEmail(s: string | undefined): string | undefined {
  if (typeof s !== "string") return undefined;
  const t = s.trim();

  return t.includes("@") ? t : undefined;
}

export function getTmsOffersContextLabel(emailData: Email | null): string {
  if (!emailData) return "";
  const org = emailData.organization;
  const fromSender =
    trimSenderEmail(org?.sender) ?? trimSenderEmail(emailData.sender ?? undefined) ?? "";

  if (fromSender) return fromSender;
  const orgName = org?.orgName?.trim();

  if (orgName) return orgName;
  return emailData.companyName.trim();
}
export function formatTmsOffersLoadingLabel(
  providerDisplayName: string,
  emailData: Email | null
): string {
  const ctx = getTmsOffersContextLabel(emailData);

  if (ctx) {
    return `Getting ${providerDisplayName} offers for ${ctx}...`;
  }
  return `Gathering offers from ${providerDisplayName}...`;
}
